const $inject = ['$scope', '$routeParams', 'dataService'];

const lbaTextAreaCtrl = function ($scope, $routeParams, dataService) {
  const vm = this;
  const dataLookUp = dataService.spiltDataAt(vm.settings.dataAt, $routeParams);

  vm.data = _.get(dataService.data.activeItem, dataLookUp);

  $scope.$watchCollection('vm.data', (newData, oldData) => {
    if (newData !== oldData) {
      _.set(dataService.data.activeItem, dataLookUp, newData)
    }
  });
};

lbaTextAreaCtrl.$inject = $inject;

export default lbaTextAreaCtrl;


// WEBPACK FOOTER //
// ./src/components/lbaTextArea/lbaTextAreaCtrl.js